module.exports = __webpack_public_path__ + "static/media/photo1.9802495f.jpg";